import { Grid } from '@mui/material';

const HeaderMenu: React.FC = () => {
  return <Grid container spacing={2}></Grid>;
};

export default HeaderMenu;
